






















































































































































































































import { Component, Vue } from "vue-property-decorator";
import { SmartQuery } from "vue-apollo-decorator";
import SExpandable from "@/components/UI/SExpandable.vue";
import {
  GQL_taxDeductionToPay,
  GQL_taxDeductionToPay_taxDeductionToPay,
  GQL_taxDeductionToPay_taxDeductionToPay_paychecks,
} from "@/queries/__generated__/taxDeductionToPay";
import gql from "graphql-tag";

const GET_TAX_DEDUCTION_TO_PAY = gql`
  query taxDeductionToPay($year: Int!) {
    taxDeductionToPay(year: $year) {
      month
      kid
      paymentDates {
        dueDate
        taxDeductionAmount
        garnishmentAmount
        garnishmentSamordnetAmount
      }
      paychecks {
        id
        number
        employeeName
        dueDate
        amount
        taxDeductionAmount
        garnishmentAmount
        garnishmentSamordnetAmount
      }
    }
  }
`;

type UIMonthlyEntry = GQL_taxDeductionToPay_taxDeductionToPay & {
  selectedPaychecks: GQL_taxDeductionToPay_taxDeductionToPay_paychecks[];
};

@Component({
  components: {
    SExpandable,
  },
})
export default class TaxDeductionToPay extends Vue {
  private selectedYear: number = new Date().getFullYear();
  private years: number[] = [];

  created() {
    const currentYear = new Date().getFullYear();
    const startYear = 2026;

    this.years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i);
  }

  get bankAccountUrl() {
    return this.$i18n.locale === "en"
      ? "https://www.skatteetaten.no/en/bank-account-number/"
      : "https://www.skatteetaten.no/kontonummer/";
  }

  get garnishmentUrl() {
    return this.$i18n.locale === "en"
      ? "https://www.skatteetaten.no/en/about-the-tax-administration/fremtidens-innkreving/employer/"
      : "https://www.skatteetaten.no/om-skatteetaten/fremtidens-innkreving/arbeidsgivere/";
  }

  @SmartQuery<TaxDeductionToPay, GQL_taxDeductionToPay>({
    query: GET_TAX_DEDUCTION_TO_PAY,
    variables() {
      return { year: this.selectedYear };
    },
    update: data => data.taxDeductionToPay
      .map(entry => ({
        ...entry,
        selectedPaychecks: [],
      }))
      .sort((a,b) => b.month - a.month),
  }) taxDeductionToPayEntries!: UIMonthlyEntry[];


  onSelected(entry: UIMonthlyEntry, selected: GQL_taxDeductionToPay_taxDeductionToPay_paychecks[]) {
    entry.selectedPaychecks = selected;
  }

  private sumPaymentDatesTaxDeduction(entry: UIMonthlyEntry): number {
    return entry.paymentDates.reduce(
      (total, paymentDate) => total + Number(paymentDate.taxDeductionAmount), 0);
  }

  private sumPaymentDatesGarnishment(entry: UIMonthlyEntry): number {
    return entry.paymentDates.reduce(
      (total, paymentDate) => total + Number(paymentDate.garnishmentAmount), 0);
  }

  private sumPaymentDatesGarnishmentSamordnet(entry: UIMonthlyEntry): number {
    return entry.paymentDates.reduce(
      (total, paymentDate) => total + Number(paymentDate.garnishmentSamordnetAmount), 0);
  }

  private sumSelectedAmounts(entry: UIMonthlyEntry): number {
    return entry.selectedPaychecks.reduce(
      (total, paycheck) => total + Number(paycheck.amount), 0);
  }

  private sumSelectedTaxDeduction(entry: UIMonthlyEntry): number {
    return entry.selectedPaychecks.reduce(
      (total, paycheck) => total + Number(paycheck.taxDeductionAmount), 0);
  }

  private sumSelectedGarnishment(entry: UIMonthlyEntry): number {
    return entry.selectedPaychecks.reduce(
      (total, paycheck) => total + Number(paycheck.garnishmentAmount), 0);
  }

  private sumSelectedGarnishmentSamordnet(entry: UIMonthlyEntry): number {
    return entry.selectedPaychecks.reduce(
      (total, paycheck) => total + Number(paycheck.garnishmentSamordnetAmount), 0);
  }
}
